import { Controller } from '@hotwired/stimulus'

// Seamless right-to-left offers marquee. Content is duplicated in the template;
// animation moves exactly -50% so the loop has no visible jump.
export default class extends Controller {
  static targets = ['track']
  static values = {
    duration: { type: Number, default: 50 }
  }

  connect () {
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  }

  trackTargetConnected (track) {
    this.applyAnimation(track)
  }

  pause () {
    if (!this.hasTrackTarget || this.reducedMotion) return
    this.trackTarget.classList.add('is-paused')
  }

  resume () {
    if (!this.hasTrackTarget || this.reducedMotion) return
    this.trackTarget.classList.remove('is-paused')
  }

  applyAnimation (track) {
    const seconds = Math.max(20, this.durationValue)
    track.style.setProperty('--offers-ticker-duration', `${seconds}s`)

    if (this.reducedMotion) {
      track.classList.add('offers-ticker-track--static')
      return
    }

    track.classList.add('offers-ticker-track--animate')
  }
}
